import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/** **************************************** */
/** CONSUMER MAKE CHANGES BELOW THIS AREA * */
/** **************************************** */

// !! 1. Add new experiment ID here !!

/**
 * these are the experiments that are integrated/De-Integrated
 * Please move the integrated/De-Integrated experiments to this section to prevent the breaking change on the consumer side.
 */

// !! 2. Map experiment ID to the ID in Calculon here !!
// If experiment is dynamic, eg. the experiment ID is different for different consumers or only ran at specific consumers, map to null
// If mapped to null, consumer has to do the mapping manually in the consumer side overrides
var experimentMappings = {
  isMigratingNotificationToAccessibleColor: 'WLBE-402',
  deprecateInaccessibleColor: 'ADSEFF-309',
  isToggleButtonAccessibilityColorFix: 'ADSEFF-448',
  iconsMigrationToV3: 'ADSREQ-1614',
  isGetDroneContextFromWindow: 'ADSEFF-316',
  cssArchitecture: null,
  gridSizeFallback: null,
  isZoomFontSizeFix: null,
  alwaysMountTooltip: null,
  // Integrated
  hideHorizontalScrollFadeOnSmallScreens: null,
  // Integrated
  inputTrailingAssetPaddingFix: null,
  // De-Integrated
  radioCheckboxA11yContrastFix: 'ADSEFF-539',
  searchFieldMinHeight: 'ADSEFF-597',
  incorrectInertAttrOnCarouselWhenResizing: 'AVENGERS-2732',
  isMigratingChipToAccessibleColor: 'ADSEFF-720',
  isMigratingBadgeToAccessibleColor: 'ADSEFF-745',
  radioCheckboxFocusStateContrastFix: 'AVENGERS-2896'
};
var experimentMappingsNew = {
  isMigratingNotificationToAccessibleColor: {
    calculonId: 'WLBE-402',
    status: 'active'
  },
  hideHorizontalScrollFadeOnSmallScreens: {
    calculonId: null,
    status: 'integrated'
  },
  deprecateInaccessibleColor: {
    calculonId: 'ADSEFF-309',
    status: 'active'
  },
  isToggleButtonAccessibilityColorFix: {
    calculonId: 'ADSEFF-448',
    status: 'active'
  },
  iconsMigrationToV3: {
    calculonId: 'ADSREQ-1614',
    status: 'active'
  },
  isGetDroneContextFromWindow: {
    calculonId: 'ADSEFF-316',
    status: 'active'
  },
  alwaysMountTooltip: {
    calculonId: null,
    status: 'active'
  },
  cssArchitecture: {
    calculonId: null,
    status: 'active'
  },
  gridSizeFallback: {
    calculonId: null,
    status: 'active'
  },
  isZoomFontSizeFix: {
    calculonId: null,
    status: 'active'
  },
  inputTrailingAssetPaddingFix: {
    calculonId: null,
    status: 'active'
  },
  radioCheckboxA11yContrastFix: {
    calculonId: 'ADSEFF-539',
    status: 'active'
  },
  searchFieldMinHeight: {
    calculonId: 'ADSEFF-597',
    status: 'active'
  },
  incorrectInertAttrOnCarouselWhenResizing: {
    calculonId: 'AVENGERS-2732',
    status: 'active'
  },
  isMigratingChipToAccessibleColor: {
    calculonId: 'ADSEFF-720',
    status: 'active'
  },
  isMigratingBadgeToAccessibleColor: {
    calculonId: 'ADSEFF-745',
    status: 'active'
  },
  radioCheckboxFocusStateContrastFix: {
    calculonId: 'AVENGERS-2896',
    status: 'active'
  }
};

/** **************************************** */
/** CONSUMER DO NOT EDIT BELOW THIS AREA  * */
/** **************************************** */

var defaultExperimentContext = Object.keys(experimentMappings).reduce(function (acc, key) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, false));
}, {});
var mapExperimentsToContext = function mapExperimentsToContext(mappings, isB) {
  var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var mappedExps = Object.entries(mappings).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      experiment = _ref2[1];
    var typedKey = key;
    if (experiment) {
      acc[typedKey] = isB(experiment, key);
    } else {
      acc[typedKey] = false;
    }
    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, mappedExps), overrides);
};
var createMapperV2 = function createMapperV2(getMappings) {
  return function (isB) {
    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isBWrapper = function isBWrapper(expCalculonId, expKey) {
      var _isB;
      return (_isB = isB(expCalculonId !== null && expCalculonId !== void 0 ? expCalculonId : '', expKey)) !== null && _isB !== void 0 ? _isB : false;
    };
    return _objectSpread(_objectSpread({}, getMappings(isBWrapper)), overrides);
  };
};
var mapDesignSystemExperiments = createMapperV2(function (isB) {
  return _objectSpread({}, mapExperimentsToContext(experimentMappings, isB));
});
var ExperimentsPipeline = {
  mapDesignSystemExperiments: mapDesignSystemExperiments
};

/** **************************************** */
/**            Types start                * */
/** **************************************** */

/** **************************************** */
/**              Types end                * */
/** **************************************** */

var ExperimentContext = /*#__PURE__*/React.createContext(defaultExperimentContext);
var useExperimentContext = function useExperimentContext() {
  return React.useContext(ExperimentContext);
};
var ExperimentContextProvider = /*#__PURE__*/React.memo(function (_ref3) {
  var children = _ref3.children,
    value = _ref3.value;
  return /*#__PURE__*/React.createElement(ExperimentContext.Provider, {
    value: value
  }, children);
});
ExperimentContextProvider.displayName = 'ExperimentContextProvider';

export { ExperimentContextProvider, ExperimentsPipeline, createMapperV2, defaultExperimentContext as defaultExperiment, experimentMappings, experimentMappingsNew, mapExperimentsToContext, useExperimentContext };
//# sourceMappingURL=Experiment.js.map
